import { HeartHandshake } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const HumanitarianParoleTPS = () => {
  const faqs = [
    {
      question: "How long does humanitarian parole last?",
      answer: "Humanitarian parole is typically granted for a specific period needed to accomplish the stated purpose, often 1-2 years. It can sometimes be extended. Parole does not provide a path to permanent residence but may allow you to apply for other immigration benefits while in the U.S.",
    },
    {
      question: "Can TPS lead to a green card?",
      answer: "TPS itself doesn't provide a direct path to permanent residence. However, TPS beneficiaries may be eligible to adjust status through other means (family petitions, employment sponsorship, etc.). TPS provides legal status and work authorization while you're in the U.S.",
    },
  ];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        <h2 className="text-3xl font-bold mb-6">Emergency Immigration Relief</h2>
        <p className="text-xl text-muted-foreground mb-8">
          Humanitarian parole and Temporary Protected Status (TPS) provide crucial protection for individuals facing urgent circumstances or country conditions that prevent safe return.
        </p>

        <h3 className="text-2xl font-bold mb-4">Humanitarian Parole</h3>
        <p className="mb-6">
          Allows individuals to temporarily enter or remain in the U.S. for urgent humanitarian reasons or significant public benefit. Common situations include:
        </p>
        <ul className="list-disc pl-6 mb-6">
          <li>Medical emergencies</li>
          <li>Family emergencies</li>
          <li>Witnesses in legal proceedings</li>
          <li>Family reunification for certain nationals</li>
        </ul>

        <h3 className="text-2xl font-bold mb-4">Temporary Protected Status (TPS)</h3>
        <p className="mb-6">
          TPS provides temporary lawful status and work authorization to nationals of designated countries experiencing ongoing armed conflict, environmental disaster, or other extraordinary conditions. Currently designated countries include Venezuela, Haiti, El Salvador, Honduras, and others.
        </p>

        <h3 className="text-2xl font-bold mb-6">Frequently Asked Questions</h3>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  return (
    <GenericPracticePage
      title="Humanitarian Parole & TPS"
      subtitle="Temporary protected status and humanitarian parole for emergency situations"
      icon={<HeartHandshake className="h-20 w-20 mx-auto mb-6 text-accent" />}
      mainContent={mainContent}
    />
  );
};

export default HumanitarianParoleTPS;
